/* global grecaptcha */
(
    function ($) {
        'use strict';

        /**
         * reCAPTCHA v3 tokens expire after two minutes. The recaptchav3_html chunk only
         * requests a token on page load, so anyone who took longer than that to fill in
         * a form was rejected by the recaptchav3 hook. Request a fresh token on submit.
         */
        var Recaptcha = {
            actionSelector: 'input[name="recaptcha-action"]',

            // Submit anyway if Google does not answer in time, the server shows the error.
            timeout: 8000,

            getSiteKey: function () {
                var src = $('script[src*="recaptcha/api.js"]').attr('src') || '';
                var match = src.match(/[?&]render=([^&]+)/);

                return match ? decodeURIComponent(match[1]) : null;
            },

            // FormIt only processes a form when its submitVar (the button name) is posted.
            getSubmitter: function ($form, event) {
                var submitter = event.originalEvent && event.originalEvent.submitter;

                if (submitter && submitter.name) {
                    return submitter;
                }

                return $form.find('button[type="submit"][name], input[type="submit"][name]').get(0) || null;
            },

            submit: function ($form, submitter) {
                var form = $form.get(0);

                $form.data('recaptcha-fresh', true);

                if (typeof form.requestSubmit === 'function') {
                    if (submitter) {
                        form.requestSubmit(submitter);
                    } else {
                        form.requestSubmit();
                    }
                } else {
                    if (submitter) {
                        $('<input type="hidden">')
                            .attr('name', submitter.name)
                            .val(submitter.value)
                            .appendTo($form);
                    }

                    form.submit();
                }

                $form.removeData('recaptcha-fresh');
            },

            onSubmit: function (event) {
                var self = this;
                var $form = $(event.currentTarget);
                var $action = $form.find(this.actionSelector);
                var $token = $action.prev('input[type="hidden"]');
                var siteKey = this.getSiteKey();
                var submitter;
                var done;

                if (event.isDefaultPrevented() || $form.data('recaptcha-fresh') || !$action.length || !$token.length) {
                    return;
                }

                // Without the API the server rejects the form and shows the error.
                if (!siteKey || typeof grecaptcha === 'undefined') {
                    return;
                }

                event.preventDefault();

                if ($form.data('recaptcha-pending')) {
                    return;
                }

                submitter = this.getSubmitter($form, event);
                $form.data('recaptcha-pending', true);

                done = function (token) {
                    if (!$form.data('recaptcha-pending')) {
                        return;
                    }

                    $form.removeData('recaptcha-pending');

                    if (token) {
                        $token.val(token);
                    }

                    self.submit($form, submitter);
                };

                setTimeout(done, this.timeout);

                grecaptcha.ready(function () {
                    grecaptcha.execute(siteKey, { action: $action.val() }).then(done, function () {
                        done();
                    });
                });
            }
        };

        $(document).on({
            submit: $.proxy(Recaptcha, 'onSubmit')
        }, 'form');
    }(jQuery)
);
